import { render, staticRenderFns } from "./magic-link-button.vue?vue&type=template&id=6d7d8622"
import script from "./magic-link-button.vue?vue&type=script&lang=js"
export * from "./magic-link-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports